import {
    CLAPI
} from '../clchart/cl.api.js'
import * as Init from '../init.js';
import * as DATAS from '../datas/transdata.js'

export const FWIDTH = 130

export const CHART_VERIFY_MCLASS = {
    style: 'horizontal', // 'vertical'
    title: {
        width: FWIDTH,
        label: '因子分类',
    },
    maxchs: 4,
    ctrls: []
}

export const CHART_VERIFY_YEAR = {
    style: 'horizontal', // 'vertical'
    title: {
        width: FWIDTH,
        label: '因子分区',
    },
    maxchs: 8,
    ctrls: []
}

export const CHART_VERIFY_FACTORS = {
    style: 'vertical', // 'vertical'
    title: {
        label: '多分类因子',
        height: 23,
    },
    ctrls: []
}
export function setFactorsTitle(name) {
    CHART_VERIFY_FACTORS.title.label = name
}
export function clearFactors() {
    CHART_VERIFY_FACTORS.ctrls = []
}

export function incrFactors(fname) {
    // console.log(fname);
    const info = {
        align : 'left',
        label: fname,
        clickValue: fname,
        value : [],
    }
    CHART_VERIFY_FACTORS.ctrls.push(info)
}

export function onInit(classes, minutes) {
    CHART_VERIFY_MCLASS.ctrls = []
    for (let wvi = 0; wvi < classes.length; wvi++) {
        CHART_VERIFY_MCLASS.ctrls.push({
            label: classes[wvi],
            clickValue: classes[wvi],
        })
    }
    CHART_VERIFY_YEAR.ctrls = []
    for (let wvi = 0; wvi < minutes.length; wvi++) {
        CHART_VERIFY_YEAR.ctrls.push({
            label: minutes[wvi],
            clickValue: minutes[wvi],
        })
    }
}

////////////////////
export function getmulFactors(indata) {
    let vars = []
    vars.push([-1, 'CN000000', '自排列统计', 1])
    for (let index = 0; index < indata.datas.length; index++) {
        const cnums = CLAPI.getData(indata, 'cnums', index)
        const alone = CLAPI.getData(indata, 'alone', index)
        if (cnums > 1 && alone === 1) {
            const cindex = CLAPI.getData(indata, 'index', index);
            const cfname = CLAPI.getData(indata, 'fname', index); 
            for (let ii = 0; ii < cnums; ii++) {
                const style = CLAPI.getData(indata, 'symbol' + ii.toString(), index)
                vars.push([cindex, cfname, cfname + '(' + String(style) + ')', style])    
            }
        }
    }
    return {
        fields: {
            index    : 0,
            fname    : 1,
            showname : 2,
            fstyle   : 3,
        },
        datas: vars.sort((x, y) => x[2].localeCompare(y[2]))
    }
}

export function getoneFactors(indata) {
    let vars = {}
    
    for (let index = 0; index < indata.datas.length; index++) {
        const cnums = CLAPI.getData(indata, 'cnums', index)
        if (cnums === 1) {
            const cfname = CLAPI.getData(indata, 'fname', index)
            vars[cfname] = CLAPI.getData(indata, 'index', index)
        }
    }
    return vars;
}
export const shapeInfo = [
    {
        label: '序号',
        field: 'index',
        maxchs: 4,
        align: 'center', // align 默认为'right'
        sort: 'resume',     // sort默认为 number  resume表示原来的序列
        getclr : 'getIntClr',
        getvar : 'getIntVar',  
    },
    {
        label: "因子名1",
        field: 'cfname0',
        maxchs: 7,
        align: 'left',  // alignTxt 默认为'right'
        // style: 'click',  // 返回 click 事件 返回 label 信息
        getclr : 'getNameClr',
        getvar : 'getStrVar',  
    },
    {
        label: "因子名2",
        field: 'cfname1',
        maxchs: 7,
        align: 'left',  // alignTxt 默认为'right'
        // style: 'click',  // 返回 click 事件 返回 label 信息
        getclr : 'getNameClr',
        getvar : 'getStrVar',  
    },
    {
        label: "因子名3",
        field: 'cfname2',
        maxchs: 7,
        align: 'left',  // alignTxt 默认为'right'
        // style: 'click',  // 返回 click 事件 返回 label 信息
        getclr : 'getNameClr',
        getvar : 'getStrVar',  
    },
    {
        label: '样本数',
        maxchs: 7,
        field: 'samples',
        getclr : 'getIntClr', 
        getvar : 'getIntVar', 
    },
    {
        label: '投资比例',
        maxchs: 7,
        field: 'oprate',
        getclr : 'getZeroClr', 
        getvar : 'getFltVar', 
    },
    {
        label: '期望收益',
        maxchs: 7,
        field: 'expect',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '涨概率',
        maxchs: 7,
        field: 'dupprob',
        range: [0.4, 0.6],
        getclr : 'getRangeClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '涨幅',
        maxchs: 7,
        field: 'duprate',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '跌概率',
        maxchs: 7,
        field: 'ddnprob',
        range: [0.4, 0.6],
        getclr : 'getRangeClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '跌幅',
        maxchs: 7,
        field: 'ddnrate',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '小涨概率',
        maxchs: 7,
        field: 'xupprob',
        getclr : 'getIntClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '小跌概率',
        maxchs: 7,
        field: 'xdnprob',
        getclr : 'getIntClr', 
        getvar : 'getPctVar', 
    },
    
];

const FIELD_SHAPE = DATAS.fieldsToFieldsIndex('index,cindex0,cindex1,cindex2,cfname0,cfname1,cfname2,findex,fstyle,samples,xup_nums,xdn_nums,xupprob,xuprate,xdnprob,xdnrate,dup_nums,ddn_nums,dupprob,duprate,ddnprob,ddnrate,expect,oprate')

export function GetShapeTable(verifys, factors, findex, fstyle) {
    let vars = []
    let nums = 0
    for (let index = 0; index < verifys.datas.length; index++) {
        const alone = CLAPI.getData(verifys, 'alone', index)
        let finded = true
        if (findex == -1) {
            if (alone === 1) {
                finded = false
            }
        }
        else {
            if (alone === 0 ||
                CLAPI.getData(verifys, 'findex0', index) !== findex || 
                CLAPI.getData(verifys, 'symbol0', index) !== fstyle ) {
                finded = false
            }
        }
        // console.log(finded, verifys.datas[index], alone, findex, fstyle);
        
        let finame0 = 'findex0'
        let finame1 = 'findex1'
        let finame2 = 'findex2'
        if (alone) {
            finame0 = 'findex1'
            finame1 = 'findex2'
            finame2 = 'findex3'
        }
        if (finded) {
            const cindex0 = CLAPI.getData(verifys, finame0, index)
            const cindex1 = CLAPI.getData(verifys, finame1, index)
            const cindex2 = CLAPI.getData(verifys, finame2, index)
            const cfname0 = cindex0 > 0 ? CLAPI.getData(factors, 'fname', cindex0) : '-'
            const cfname1 = cindex1 > 0 ? CLAPI.getData(factors, 'fname', cindex1) : '-'
            const cfname2 = cindex2 > 0 ? CLAPI.getData(factors, 'fname', cindex2) : '-'
            const samples = CLAPI.getData(verifys, 'samples', index)
            const dup_nums = CLAPI.getData(verifys, 'dup_nums', index)
            const ddn_nums = CLAPI.getData(verifys, 'ddn_nums', index)
            const dup_rate = CLAPI.getData(verifys, 'dup_rate', index)
            const ddn_rate = CLAPI.getData(verifys, 'ddn_rate', index)
            const xup_nums = CLAPI.getData(verifys, 'xup_nums', index)
            const xdn_nums = CLAPI.getData(verifys, 'xdn_nums', index)
            const xup_rate = CLAPI.getData(verifys, 'xup_rate', index)
            const xdn_rate = CLAPI.getData(verifys, 'xdn_rate', index)
            const dup_prob = dup_nums / samples
            const ddn_prob = ddn_nums / samples
            const xup_prob = xup_nums / samples
            const xdn_prob = xdn_nums / samples
            const oprate = CLAPI.getData(verifys, 'oprate', index)
            
            const expect = CLAPI.getData(verifys, 'expect', index)
            
            // let expect = 0.0
            // expect = dup_prob * dup_rate + ddn_prob * ddn_rate
            // expect += xup_prob * xup_rate + xdn_prob * xdn_rate
            
            // let oprate = 0.0;
            // if (dn_nums === 0) {
            //     oprate = 100.0
            // } else if (up_nums === 0) {
            //     oprate = -100.0
            // } else {
            //     oprate = upprob/Math.abs(dnrate) - dnprob/uprate
            // }
            if (samples > 0) {
                vars.push([
                    nums++,
                    cindex0,
                    cindex1,
                    cindex2,
                    cfname0,
                    cfname1,
                    cfname2,
                    findex,
                    fstyle,
                    samples,
                    xup_nums,
                    xdn_nums,
                    xup_prob,
                    xup_rate,
                    xdn_prob,
                    xdn_rate,
                    dup_nums,
                    ddn_nums,
                    dup_prob,
                    dup_rate,
                    ddn_prob,
                    ddn_rate,
                    expect,
                    oprate, 
                ])
            }
        }
    }
    return { fields : FIELD_SHAPE, datas: vars}  
}